import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
  codigo: string | null;
  descricao: string | null;
  status: number | null;
  localizacao: string | null;
  centroCusto: number[] | null;
};

type Actions = {
  setCodigo: (codigo: string | null) => void;
  setDescricao: (descricao: string | null) => void;
  setStatus: (status: number | null) => void;
  setLocalizacao: (localizacao: string | null) => void;
  setCentroCusto: (centroCusto: number[] | null) => void;
  clear: () => void;
};

export const initialMaquinasEquipListaFilters: State = {
  codigo: null,
  descricao: null,
  status: 2,
  localizacao: null,
  centroCusto: null,
};

export const useMaquinasEquipListaFilters = create<State & Actions>((set) => ({
  ...initialMaquinasEquipListaFilters,

  setCodigo: (codigo) => set({ codigo }),
  setDescricao: (descricao) => set({ descricao }),
  setStatus: (status) => set({ status }),
  setLocalizacao: (localizacao) => set({ localizacao }),
  setCentroCusto: (centroCusto) => set({ centroCusto }),
  clear: () => set({ ...initialMaquinasEquipListaFilters }),
}));
